import { useLocalStorage } from "@src/appV2/lib/utils";

import { DocumentsUnlockBanner } from "../components/UnlockBanner";
import { EducationalJobsButton } from "./EducationalJobsButton";
import { useDocumentsPageApiContext } from "./useApiProvider";
import { useDocumentsPageNavigationContext } from "./useNavigation";

export function DocumentsPageContentEducationalBanner() {
  const { selectedTab } = useDocumentsPageNavigationContext();
  const {
    incompleteWorkplaceSpecificRequirementsQuery: {
      data: incompleteData,
      isSuccess: isSuccessIncomplete,
    },
  } = useDocumentsPageApiContext();

  const hasIncompleteDocuments =
    isSuccessIncomplete && incompleteData?.pages?.flatMap((page) => page).length > 0;

  const [isUnlockWorkplacesBannerDismissed, setIsUnlockWorkplacesBannerDismissed] =
    useLocalStorage<boolean>("documents-unlock-workplaces-banner-dismissed", false);
  const [isUnlockShiftBannerDismissed, setIsUnlockShiftBannerDismissed] = useLocalStorage<boolean>(
    "documents-unlock-shift-banner-dismissed",
    false
  );

  return (
    <>
      {selectedTab === "mandatory" && !isUnlockWorkplacesBannerDismissed && (
        <DocumentsUnlockBanner
          variant="mandatory"
          onClose={() => {
            setIsUnlockWorkplacesBannerDismissed(true);
          }}
        >
          <EducationalJobsButton />
        </DocumentsUnlockBanner>
      )}

      {selectedTab === "workplaceSpecific" &&
        !isUnlockShiftBannerDismissed &&
        hasIncompleteDocuments && (
          <DocumentsUnlockBanner
            variant="workplaceSpecific"
            onClose={() => {
              setIsUnlockShiftBannerDismissed(true);
            }}
          >
            <EducationalJobsButton />
          </DocumentsUnlockBanner>
        )}
    </>
  );
}
